import * as firebase from 'firebase/app';

const config = {
  apiKey: 'AIzaSyC5AyzXDhaiB7UkB6eFY852UKP3olmYXCU',
  authDomain: 'whatthefffake.firebaseapp.com',
  databaseURL: 'https://whatthefffake.firebaseio.com',
  projectId: 'whatthefffake',
  storageBucket: 'whatthefffake.appspot.com',
  messagingSenderId: '516844873506',
};

const devconfig = {
  apiKey: 'AIzaSyAwi7ZUl0vljwdsOcEt8jvOdDclroDlhrs',
  authDomain: 'what-the-fake---dev.firebaseapp.com',
  databaseURL: 'https://what-the-fake---dev.firebaseio.com',
  projectId: 'what-the-fake---dev',
  storageBucket: 'what-the-fake---dev.appspot.com',
  messagingSenderId: '755741814004',
  appId: '1:755741814004:web:5109c1c79d74c658e782a1',
};

const firebaseApp = firebase.initializeApp(config);
// firebase.firestore().enablePersistence();

export default firebaseApp;
